<template>
  <v-card
    :class="currentlyViewedChallenge.isFacilitator || currentlyViewedChallenge.isCofacilitator ? 'mx-auto hmw drag-drop' : 'mx-auto hmw'"
    height="200"
    width="200"
    elevation="20"
    data-thoughttype="HMW"
    :data-thoughtid=HMW.uuid
    light>
      <v-container fill-height>
        <v-row justify="center">
          {{ HMW.content }}
        </v-row>
      </v-container>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'HMW',
  props: ['HMW'],
  data: () => ({
    windowHeight: window.innerHeight
  }),
  computed: {
    ...mapState({
      currentlyViewedChallenge: state => state.challenge.currentlyViewedChallenge
    }),
    height: function () {
      return this.windowHeight - 60
    }
  },
  created () {
    window.addEventListener('resize', () => {
      this.windowHeight = window.innerHeight
    })
  },

  destroyed () {
    window.removeEventListener('resize', () => {
      this.windowHeight = window.innerHeight
    })
  }
}
</script>

<style lang="sass" scoped>
  .hmw
    margin: 1em
    text-align: center
    touch-action: none
</style>
